import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { observer } from "mobx-react";
import { Outlet } from "react-router-dom";
import { useStores } from "../../../../store";
import { Spin } from "antd";
import { ConfigHintModal } from "../..";
const TcfLayout = observer(()=>{
    const { tcfStore } = useStores();
    const { purposes } = tcfStore;
    // Load all declarations
    useEffect(()=>{
        tcfStore.fetchDeclarations();
    }, []);
    return purposes.size === 0 ? /*#__PURE__*/ _jsx(Spin, {
        style: {
            margin: "auto",
            marginTop: 15
        }
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Outlet, {}),
            /*#__PURE__*/ _jsx(ConfigHintModal, {
                identifier: "tcf-vendor"
            })
        ]
    });
});
export { TcfLayout };
